(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('MyProfileController', MyProfileController)

    /** @ngInject */
    function MyProfileController($q, LoadingHelper, PersonService, MeService, ValidatorHelper, AuthenticationService,
        NotifyHelper, UtilHelper, FlowConfigurationHelper, sweetAlert, ImagePathHelper) {
        const vm = this;

        vm.passwordValidator = ValidatorHelper.validatePassword;

        // Main image
        vm.flowFileAdded = $file => {
            let blacklist = ['png', 'gif', 'jpg', 'jpeg'];
            let extension = $file.getExtension();

            if (!blacklist.includes(extension)) {
                UtilHelper.setErrorMessageForm('.image-block', 'Formato inválido.', true);
                return false;
            }

            vm.oldFormImageMain = vm.mainImageData.Url;

            LoadingHelper.startLoading('.image-loading-holder');

            UtilHelper.removeErrorMessageForm('.image-block');
        }

        vm.flowFileFinishedMain = ($file, $message) => {
            let message = angular.fromJson($message);

            vm.mainImageData.Url = message.FileSaveName;

            vm.saveMyProfile();
        }

        vm.deleteImage = imageData => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.image-loading-holder');

                    MeService
                        .deleteImage(imageData.Id)
                        .then(() => {
                            if (!imageData.Main) {
                                var index = vm.companyGallery.indexOf(imageData);

                                if (index !== -1)
                                    vm.companyGallery.splice(index, 1);
                            } else {
                                vm.mainImageData = {
                                    Url: '',
                                    Display: ''
                                }

                                if (vm.flowScopeMain.flow.files.length)
                                    vm.flowScopeMain.flow.files[0].cancel();
                            }

                            LoadingHelper.stopLoading('.image-loading-holder');
                            UtilHelper.successCallback();
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.image-loading-holder');
                        })
                }
            })
        }

        vm.saveMyProfile = () => {
            LoadingHelper.startLoading('.loading-holder');

            let personData = {
                Image: vm.mainImageData.Url || null,
                Name: vm.personData.Name,
                GenderId: vm.selectedGender.Id,
                BirthDate: UtilHelper.convertToMomentDate(vm.personData.BirthDateFormatted).format('YYYY-MM-DD')
            }

            let personDocuments = vm.personData.PersonDocuments.reduce((acc, cur) => {
                acc.push({
                    DocumentTypeId: cur.DocumentTypeId,
                    Code: cur.Code
                })

                return acc;
            }, []);

            if (!personDocuments.find(x => x.DocumentTypeId == 1)) {
                sweetAlert.swal({
                    title: 'Aviso',
                    text: 'Você também deve informar o seu CPF no cadastro!',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })

                LoadingHelper.stopLoading('.loading-holder');
                return;
            }

            let personEmails = vm.personData.PersonEmails.reduce((acc, cur) => {
                acc.push({
                    EmailTypeId: cur.EmailTypeId,
                    Email: cur.Email
                })

                return acc;
            }, []);

            let personTelephones = vm.personData.PersonPhones.reduce((acc, cur) => {
                acc.push({
                    PhoneTypeId: cur.PhoneTypeId,
                    AreaCode: cur.AreaCode,
                    PhoneNumber: cur.PhoneNumber
                })

                return acc;
            }, []);

            personData.PersonDocuments = personDocuments;
            personData.PersonEmails = personEmails;
            personData.PersonPhones = personTelephones;

            MeService
                .updateMe(personData)
                .then(() => {
                    vm.personData.Image = personData.Image;
                    vm.mainImageData.Url = personData.Image;
                    vm.mainImageData.Display = ImagePathHelper.imageResizePath('person', vm.personData.Id, vm.personData.Image, 150, 150);

                    AuthenticationService.updateUser(vm.personData);

                    UtilHelper.successCallback();
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        vm.saveMyPassword = () => {
            LoadingHelper.startLoading('.loading-holder');

            let personPasswordData = {
                NewPassword: Encrypt.Hash(vm.changePasswordData.NewPassword).toString(),
                OldPassword: Encrypt.Hash(vm.changePasswordData.OldPassword).toString()
            }

            MeService
                .updateMePassword(personPasswordData)
                .then(() => {
                    NotifyHelper.success('Senha alterada com sucesso');
                    LoadingHelper.stopLoading('.loading-holder');

                    vm.cancelEditPassword();
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        vm.editPassword = () => {
            vm.isEditingPersonData = false;
            vm.isEditingPasswordData = true;
        }

        vm.cancelEditPassword = () => {
            vm.isEditingPersonData = true;
            vm.isEditingPasswordData = false;
            vm.changePasswordData = {};
        }

        init();

        function getGenders() {
            return PersonService
                .getGenders()
                .then(success => {
                    vm.genders = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                })
        }

        function getPerson() {
            const loggedPersonId = AuthenticationService.getUser().PersonId;

            if (!loggedPersonId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os seus dados!',
                    text: 'Ocorreu um erro ao buscar o seu identificador',
                    type: 'warning',
                    confirmButtonText: 'Ir para Login',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        LoadingHelper.stopLoading('.loading-holder');

                        AuthenticationService.logout();
                    }
                })

                return;
            }

            PersonService
                .get(loggedPersonId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedRegistrationDate = '-';

                    if (success.BirthDate)
                        success.BirthDateFormatted = moment(success.BirthDate).format('DD/MM/YYYY');

                    vm.personData = success;

                    if (vm.personData.GenderId)
                        vm.selectedGender = vm.genders.find(gender => (gender.Id == vm.personData.GenderId));

                    if (vm.personData.Image) {
                        vm.mainImageData.Url = vm.personData.Image;
                        vm.mainImageData.Display = ImagePathHelper.imageResizePath('person', vm.personData.Id, vm.personData.Image, 150, 150);
                    }

                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function initVars() {
            vm.selectedTab = 1;
            vm.isEditingPersonData = true;
            vm.isEditingPasswordData = false;
            vm.changePasswordData = {};

            vm.mainImageData = {
                Url: '',
                Display: ''
            }

            vm.flowOptionsMain = {
                query: () => {
                    return {
                        Path: `person/${vm.personData.Id}`,
                        OldImage: vm.oldFormImageMain,
                        CreateThumb: false,
                        CreateThumbAdmin: false,
                        MaxSize: 2000000
                    }
                }
            }

            angular.extend(vm.flowOptionsMain, FlowConfigurationHelper.getFlowOptionsDefaults());
        }

        function init() {
            initVars();

            LoadingHelper.startLoading('.loading-holder');

            $q.all([getGenders()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());